import clsx from 'clsx';
import React, { useMemo } from 'react';
import { TableSectionContext, } from './TableSectionContext';
export function TableSection(props) {
    const { children, className, elementType: Element = 'tbody', ...rest } = props;
    const section = Element.substring(1);
    return (React.createElement(TableSectionContext.Provider, { value: useMemo(() => ({ section }), [section]) },
        React.createElement(Element, { ...rest, className: clsx(`mollie-ui-table-${section}`, className), role: "rowgroup" }, children)));
}
TableSection.displayName = 'Table.Section';
//# sourceMappingURL=TableSection.js.map